<app-navbar-style-one></app-navbar-style-one>


<!-- Start Page Title Area -->
<div class="page-title-area" style="background-image: url('assets/img/page-title/page-title6.jpg');">
  <div class="container">
    <div class="page-title-content">
      <h2>{{'Tawtheeq_Policy' | translate }}</h2>
      <ul>
        <li><a routerLink="/">{{'Home' | translate }}</a></li>
        <li>{{'Tawtheeq_Policy' | translate }}</li>
      </ul>
    </div>
  </div>
</div>
<!-- End Page Title Area -->



<!-- Start Policy Area -->
<section class="policy-area ptb-100">
  <div class="container">
    <table class="table table-bordered w-full">
      <thead style="background-color: dodgerblue;">
        <tr>
          <th>{{'File_Name' | translate}}</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let file of policyFiles">
          <td>
            <span *ngIf="translate.currentLang == 'ar'">{{ file.nameAr }}</span>
            <span *ngIf="translate.currentLang == 'en'">{{ file.name }}</span>          
          </td>
          <td style="width: 100px; text-align: center;">
            <p style="color: darkblue; font-weight: bold; cursor: pointer;" (click)="downloadFile(file.filePath)">{{'Click_here' | translate}}</p>
            
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</section>
<!-- End Policy Area -->


<app-footer-style-two></app-footer-style-two>
